var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    [
      _c("FavoritePlayerSelection", {
        attrs: {
          selectedClubCode: _vm.clubCode,
          filteredPlayerList: _vm.filteredPlayerList,
          selectedPlayerIds: _vm.selectedPlayerIds,
          isUpdating: _vm.isUpdating,
          clubFavoritePlayerList: _vm.clubFavoritePlayerList,
        },
        on: {
          "go-to-club-selection": _vm.goToClubSelection,
          "update-favorite-players": _vm.updateFavoritePlayers,
          "fetch-favorite-players": _vm.fetchFavoritePlayers,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }